const DATA_TYPES = [
  { label: "String", value: "String" },
  { label: "Number", value: "Number" },
  { label: "Date", value: "Date" },
  { label: "DateTime", value: "DateTime" },
  { label: "Time", value: "Time" },
  { label: "TimeDelta", value: "TimeDelta" },
  { label: "Boolean", value: "Boolean" },
  { label: "List", value: "List" }
]
const DATA_TYPES_FLAT = {
  String: "String",
  Number: "Number",
  Date: "Date",
  DateTime: "DateTime",
  Time: "Time",
  TimeDelta: "TimeDelta",
  Boolean: "Boolean",
  List: "List",
  Json: "Json"
}

export { DATA_TYPES, DATA_TYPES_FLAT }
